(function() {
    'use strict';
    angular.module('voyageReport', ['ui.router']);
}());